import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { QRCodePage } from '../../qrcode/qrcode';
import { SessionProvider } from '../../../../providers/session/session';
import { EventProvider } from '../../../../providers/event/event';
import { EventTabsPage } from '../../../event/details/event-tabs/event-tabs';

@Component({
	selector: 'page-mysport-purchases',
	templateUrl: 'mysport-purchases.html'
})
export class MysportPurchasesPage {
	events = [];

	constructor(
		private navCtrl: NavController,
		private sessionService: SessionProvider,
		private eventService: EventProvider
	) { }

	ionViewDidLoad() {
		this.sessionService.getToken().then(token => {
			this.eventService.getMyPurchases(token).then((purchases) => {
				this.events = purchases;
			});
		});
	}

	openEvent(event) {
		this.eventService.getEventDetailsById(event.id).then(event => {
			this.navCtrl.push(EventTabsPage, { event: event })
		});
	}
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-purchases/mysport-purchases.ts